import { _plus, _percentage, _times, _minus } from '@/helpers/bigNumber'
import { isIRPF } from '@/helpers/checkTaxIsIRPF'
import numbro from '@/helpers/numbro'
import i18n from '@/i18n'

const sections = {
  data: [ 'invoiceId', 'format', 'created', 'issue', 'billPeriod', 'billRectified', 'billProcedure', 'concept' ],
  fundProvision: [ 'fundProvision' ]
}

export const visualizeInvoiceData = state => {
  let view = {}
  if (!state.invoice) return view
  view.invoiceId = { ...state.invoice.invoiceId }
  view.format = state.invoice.format
  view.created = state.invoice.created
  view.issue = state.invoice.issue
  view.incomeDate = state.invoice.incomeDate
  if (state.invoice.billPeriod && (state.invoice.billPeriod.start || state.invoice.billPeriod.end)) {
    view.billPeriod = state.invoice.billPeriod
  }
  if (state.invoice.type === 'PAYMENT') view.billProcedure = state.invoice.paidRectified
  else if (state.invoice.type === 'RECTIFIED') view.billRectified = state.invoice.paidRectified
  if (!state.invoice.type) {
    if (state.invoice.onlySupplied) {
      view.onlySupplied = 'Sí'
    } else if (!state.invoice.onlySupplied && state.invoice.invoiceType === 'thirdParty') {
      view.onlySupplied = 'No'
    } else {
      view.onlySupplied = undefined
    }
  } else {
    view.onlySupplied = undefined
  }
  view.concept = state.invoice.concept
  view.status = i18n.t(`charts.label.${state.invoice.status}`)
  if (state.invoice.status === '7' || state.invoice.status === '29') {
    view.reason = state.invoice.rejectedReason
  }
  if (state.invoice.certSigned) {
    view.certificate = {
      signatureDate: state.invoice.certSigned.signatureDate,
      issuer: state.invoice.certSigned.issuer,
      organization: state.invoice.certSigned.organization,
      serialNumber: state.invoice.certSigned.serialNumber,
      validity: {
        dateStart: state.invoice.certSigned.dateStart,
        dateExpiry: state.invoice.certSigned.dateExpiry
      }
    }
  }
  return view
}

const taxesTotalPercent = (taxes) => {
  if (!taxes) return 0
  return taxes.reduce((acc, x) => {
    return isIRPF(x.type)
            ? _minus(acc, Number(x.percent))
            : _plus(acc, Number(x.percent))
  }, 0)
}

const discountsAmount = (discounts) => {
  if (!discounts) return 0
  return discounts.reduce((acc, x) => {
    return x.type === '2'
            ? _minus(acc, Number(x.amount))
            : _plus(acc, Number(x.amount))
  }, 0)
}

export const visualizediscountsCharges = (state) => {
  if (!state.invoice || !state.invoice.discountsCharges) return []
  let base = state.invoice.totalGross
  return state.invoice.discountsCharges.map(dc => Object.assign({ base }, dc))
}

export const visualizeFactoring = (state, getters) => {
  if (!state.invoice || !state.invoice.invoiceFactoring) return []
  return state.invoice.invoiceFactoring
}

export const visualizeInvoiceDetails = (state, getters) => {
  let view = []
  if (!state.invoice || !state.invoice.invoiceLines) return view
  return state.invoice.invoiceLines.map(x => {
    let totalDiscounts = x.totalDiscounts || discountsAmount(x.discountsCharges)
    let taxesPercent = x.taxesPercent ? x.taxesPercent : taxesTotalPercent(x.taxes)
    let totalTaxes = _times(_plus(x.amountBeforeTaxes), _percentage(taxesPercent))
    let subtotal = x.amountBeforeTaxes
    return Object.assign({}, x, {
      totalDiscounts, totalTaxes, subtotal
    })
  })
}

export const totalThirdParty = (state, getters) => {
  if (!state.invoice) return {}
  let thirdPartyInvoices = state.invoice.thirdPartyInvoices || []
  return thirdPartyInvoices.reduce((acc, k) => {
    return _plus(acc, k.amount)
  }, 0)
}

export const visualizeAmmountSummary = (state, getters) => {
  if (!state.invoice) return {}
  let totalOthers = _plus(state.invoice.totalOthers, getters['totalThirdParty'])
  return {
    totalGross: numbro(state.invoice.totalGross || 0).formatCurrency('0,0.00'),
    totalDisc: numbro(state.invoice.totalDiscounts || 0).formatCurrency('0,0.00'),
    totalTaxes: numbro(state.invoice.totalTaxes || 0).formatCurrency('0,0.00'),
    totalOthers: numbro(totalOthers || 0).formatCurrency('0,0.00'),
    total: numbro(state.invoice.total || 0).formatCurrency('0,0.00')
  }
}

export const visualize = state => s => {
  return Object.keys(sections).some(x => x === s)
          ? sections[s]
          .reduce((acc, k) => {
            acc[k] = state.invoice[k]
            return acc
          }, {})
          : state.invoice[s]
}
